import {
    Zap, Sun, Video, Wifi, BatteryCharging, ShieldCheck, Globe,
    HeartHandshake, Wrench, Home, Store, Building2, Phone, MapPin,
    Menu, X, ArrowRight, CheckCircle2, RefreshCw, Plug, ChevronDown, Download,
} from "lucide-react";

const ICONS = {
    zap: Zap,
    sun: Sun,
    video: Video,
    wifi: Wifi,
    battery: BatteryCharging,
    shield: ShieldCheck,
    globe: Globe,
    handshake: HeartHandshake,
    wrench: Wrench,
    home: Home,
    store: Store,
    building: Building2,
    phone: Phone,
    mappin: MapPin,
    menu: Menu,
    x: X,
    arrow: ArrowRight,
    check: CheckCircle2,
    refresh: RefreshCw,
    plug: Plug,
    chevron: ChevronDown,
    download: Download,
};

export default function Icon({ name, size = 20, className = "", strokeWidth = 1.8 }) {
    const Cmp = ICONS[name] || Zap;
    return <Cmp size={size} className={className} strokeWidth={strokeWidth} aria-hidden="true" />;
}
